export default __webpack_public_path__ + "static/media/40301.13ed7492.jpg";